import React from 'react';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

const SearchLoadingIndicator: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-start">
      <Spin size="small" />
      <span className="ml-2">{t('common.loading')}...</span>
    </div>
  );
};

export default SearchLoadingIndicator;
